"use strict";

import foerdermoduleRegistry from "dias/foerderantrag/foerdermodule";

const pruefung_betreuungsverhaeltnis = angular.module("dias.standard_foerdermodule.pruefung_betreuungsverhaeltnis", [
  foerdermoduleRegistry.name,
]);

export default pruefung_betreuungsverhaeltnis;
